import { Route, Router } from '../../routing';
import Dashboard from './views/Dashboard';
import Config from './views/Config';
import ManagementQueryOverview from '../management/views/ManagementQueryOverview';

export const EXAM_REPORT_OVERVIEW_ROUTE = '/beheer/rapporten';
export const EXAM_REPORT_CREATE_ROUTE = `${EXAM_REPORT_OVERVIEW_ROUTE}/aanmaken`;

export const ADMIN_CONFIG_ROUTE = '/beheer/configuratie';
export const ADMIN_MANAGEMENT_QUERY_OVERVIEW_ROUTE =
  '/beheer/management-queries';

const dashboard = new Route('Dashboard', '/', <Dashboard />, true).role(
  'ROLE_ADMIN',
);
Router.addRoute(dashboard);

const config = new Route('Configuratie', ADMIN_CONFIG_ROUTE, <Config />).role(
  'ROLE_SUPER_ADMIN',
);
Router.addRoute(config);

const managementQueryOverview = new Route(
  'Managementrapportages',
  ADMIN_MANAGEMENT_QUERY_OVERVIEW_ROUTE,
  <ManagementQueryOverview />,
).role([
  'ROLE_ADMIN',
  'ROLE_OPERATOR_USER',
  'ROLE_SWIMMING_LESSON_PROVIDER_MANAGER',
]);
Router.addRoute(managementQueryOverview);
